import type { Store } from 'typesafe-actions';

import env from '@travel/env';

import { EMPTY_OBJECT } from 'favoriteList/constants/defaultValue';
import { encode } from 'js-base64';

type RequestInterceptorOptions = {
  options: any;
  path: string;
  url: string;
  isThirdPartyApi: boolean;
  customParams?: { isTravelAPI: boolean; baseURL: string };
};

const requestInterceptor =
  (store: Store) =>
  ({ path, options, url, isThirdPartyApi, customParams }: RequestInterceptorOptions) => {
    const state = store.getState();
    const { normalizedCookies } = state._httpRequest;
    const { currency, market } = state._i18n;

    let verbose = false;
    if (normalizedCookies) {
      verbose = 'trv-very-verbose' in normalizedCookies;
    }
    const isServer = typeof window === 'undefined';
    const isMock = env('UNIVERSAL_ENV_NAME') === 'MOCK';
    const { isTravelAPI, baseURL } = customParams || {};
    const basePath = isTravelAPI
      ? env('UNIVERSAL_API_BASE_PATH_TRAVEL_API')
      : isServer
        ? env('UNIVERSAL_API_BASE_PATH_SERVER')
        : env('UNIVERSAL_API_BASE_PATH_CLIENT');
    const isPathUrlEqual = url === path; // for global-header/footer request
    const newUrl = `${baseURL}${basePath}${path}`;

    // To make sure that we will send user credential only if url is under the same origin for 3rd party
    const credentials = isThirdPartyApi ? 'same-origin' : options.credentials;
    const {
      item: { token },
    } = store.getState().authCode;

    const setSessionIdHeader = () => {
      const sessionId = normalizedCookies['f_id_session']?.value;
      if (!options.headers?.fIdSession && sessionId) {
        options.headers.fIdSession = encode(sessionId);
      }
    };

    setSessionIdHeader();

    const result = {
      url: isMock || isThirdPartyApi || isPathUrlEqual ? url : newUrl,
      options: {
        ...options,
        credentials,
        headers: isThirdPartyApi
          ? EMPTY_OBJECT
          : {
              ...options.headers,
              'trv-device-id': normalizedCookies['trv-device-id']?.value,
              'trv-currency': currency,
              'trv-language': 'ja-JP',
              'trv-market': market?.marketCode,
              'trv-designation': 'standard',
              ...(isTravelAPI
                ? {
                    'trv-request-source': 'domestic',
                    'trv-rz-cookie': normalizedCookies['Rz']?.value,
                  }
                : {}),
            },
      },
      verbose,
    };

    if (token && !isThirdPartyApi) {
      result.options.headers.Authorization = token;
    }

    return result;
  };

export default requestInterceptor;
